import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "general"
    }}>{`General`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "body.md"
        }}>{`body`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "head.md"
        }}>{`head`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "html.md"
        }}>{`html`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "link.md"
        }}>{`link`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "script.md"
        }}>{`script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "style.md"
        }}>{`style`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Unsupported%20Attributes.md"
        }}>{`Unsupported Attributes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Unsupported%20Elements.md"
        }}>{`Unsupported Elements`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      